// Generated by tools/export-splash.mjs from src/i18n/<locale>.json — do not edit.
export const SPLASH_LABELS: Readonly<Record<string, readonly [label: string, accessibilityLabel: string]>> = {
  "en": ["Opening case","Detectea is loading"],
  "fr": ["Ouverture de l'affaire","Detectea se charge"],
  "de": ["Fall wird geöffnet","Detectea wird geladen"],
  "es": ["Abriendo caso","Detectea se está cargando"],
  "it": ["Apertura del caso","Detectea si sta caricando"],
  "pt-BR": ["Abrindo caso","Detectea está carregando"],
};
